import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '@edx/frontend-platform/i18n';
import { Button, ModalDialog, Spinner } from '@openedx/paragon';
import { ReactComponent as ConfirmationIcon } from './svg/confirmIcon.svg';
import messages from './messages';

const ConfirmationModal = ({
  intl,
  data,
  handleClose,
  handleConfirmation,
  children,
  buttonText,
  isOpen,
}) => (
  <ModalDialog
    isOpen={isOpen}
    size="md"
    onClose={() => handleClose()}
    variant="block"
    isFullscreenOnMobile
    className="confirmation-modal"
  >
    <ModalDialog.Header>
      <ModalDialog.Title>{intl.formatMessage(messages.title)}</ModalDialog.Title>
      <ConfirmationIcon />
    </ModalDialog.Header>
    <ModalDialog.Body>
      <h3>{intl.formatMessage(messages.confirmation)}</h3>
      <div className="confirm-message">{children}</div>
      <div className="modal-cta d-flex justify-content-center pb-3">
        <Button variant="outline-secondary" onClick={() => handleClose()}>
          {intl.formatMessage(messages.cancel)}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            handleConfirmation();
          }}
        >
          {buttonText ?? intl.formatMessage(messages.confirm)}
        </Button>
      </div>
    </ModalDialog.Body>
  </ModalDialog>
);

export default injectIntl(ConfirmationModal);
